import React, { useEffect, useState } from 'react';
import TR from './../../Trans';
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Waiting from './../items/Waiting';
import TrackListScroller from './../items/TrackListScroller';
import sessionStore from './../../stores/session';
import favoritesStore from './../../stores/favorites';
import accountStore from '../../stores/account';

function Favorites() {
  const itemsOnPage = 500;
  const isSet = favoritesStore((state) => state.isSet);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const isWaiting = favoritesStore((state) => state.isWaiting);
  const getFavorites = favoritesStore((state) => state.getFavorites);
  const getFavoritesMore = favoritesStore((state) => state.getFavoritesMore);
  const totalCount = favoritesStore((state) => state.totalCount);
  const tracks = favoritesStore((state) => state.tracks);
  const isFinished = favoritesStore((state) => state.isFinished);
  const accountLang = accountStore((state) => state.account?.language);

  const [searchQuery, setSearchQuery] = useState(null);
  const [filteredFavorites, setFilteredFavorites] = useState(null);

  useEffect(() => { }, [accountLang]);

  useEffect(() => {
    if (!tracks) {
      getFavorites(sessionToken, itemsOnPage);
    }
  }, []);

  useEffect(() => {
    if (tracks) {
      console.log("tracks", tracks);
      setFilteredFavorites(tracks.filter(track => searchQuery ?
        track.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        track.artist.toLowerCase().includes(searchQuery.toLowerCase()) ||
        track.kcode.toLowerCase().includes(searchQuery.toLowerCase())
        : true));
    }
  }, [tracks]);

  const handleScrollDown = () => {
    getFavoritesMore(sessionToken, itemsOnPage);
  };

  const renderClearAdorment = () => {
    return <InputAdornment position="end">
      <IconButton onClick={() => clearQuery()}>
        <ClearIcon />
      </IconButton>
    </InputAdornment>;
  };

  const clearQuery = () => {
    setSearchQuery(null);
    if (tracks) {
      setFilteredFavorites(tracks);
    }
  }

  const handleSearch = (e) => {
    let query = e.target.value;
    setSearchQuery(query);
    if (tracks) {
      setFilteredFavorites(tracks.filter(track => query ?
        track.title.toLowerCase().includes(query.toLowerCase()) ||
        track.artist.toLowerCase().includes(query.toLowerCase()) ||
        track.kcode.toLowerCase().includes(query.toLowerCase())
        : true));
    }
  };

  const renderSearchField = () => {
    return <TextField
      className={"muvika-search-filter"}
      onChange={handleSearch}
      size="small"
      value={searchQuery ? searchQuery : ""}
      placeholder={TR.cm_find}
      InputProps={{
        endAdornment: (
          renderClearAdorment()
        )
      }}
    />;
  };

  return (
    <div>
      <h3>{TR.cm_favorites}</h3>
      <Grid container spacing={0}>
        <Grid item xs={5}>
          <p>
            {TR.cm_total}: {filteredFavorites?.length}
          </p>
        </Grid>
        <Grid item xs={7} sx={{ textAlign: "right" }}>
          {renderSearchField()}
        </Grid>
      </Grid>
      <TrackListScroller highlight={searchQuery} isOnFavoritesView={true} isWaiting={isWaiting} id="muvika-favorites-list" tracks={filteredFavorites ? filteredFavorites.filter(x => x.is_favorite == 1) : filteredFavorites} onScrollDown={handleScrollDown} isFinished={isFinished} />
    </div>
  );
}

export default Favorites;